/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const ArrowUp: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M11.2929 1.29349L3.58594 9.00049L4.99994 10.4145L10.9999 4.41449V22.0005C10.9999 22.5535 11.4479 23.0005 11.9999 23.0005C12.5519 23.0005 12.9999 22.5535 12.9999 22.0005L12.9999 4.41449L18.9999 10.4145L20.4139 9.00049L12.7069 1.29349C12.3159 0.902487 11.6839 0.902487 11.2929 1.29349Z'
      fill='currentColor'
    />
  </React.Fragment>
)
